import type { RoomGroupCount } from "../rooms";
import type { BuildRoomExportPositions, RoomExportPosition } from "./types";

export const buildRoomExportPositions: BuildRoomExportPositions = ({
  roomElementCounts,
  groupMeta,
  boqPositions,
}) =>
  roomElementCounts.map(({ room, groups, total }) => {
    const matchedGroupsByPosition = new Map<string, RoomGroupCount[]>();
    const unmatchedGroups: RoomGroupCount[] = [];

    for (const group of groups) {
      const positionNumber = groupMeta[group.label]?.lvMatch?.lvId;
      if (positionNumber === undefined || positionNumber === "") {
        unmatchedGroups.push(group);
        continue;
      }
      const positionGroups = matchedGroupsByPosition.get(positionNumber) ?? [];
      positionGroups.push(group);
      matchedGroupsByPosition.set(positionNumber, positionGroups);
    }

    // Walk the LV in its own order; a match to a position missing from it stays unmatched, as in the Count List
    const matchedPositions = boqPositions.flatMap<RoomExportPosition>(
      (position) => {
        const positionGroups = matchedGroupsByPosition.get(
          position.position_number,
        );
        if (!positionGroups) return [];
        matchedGroupsByPosition.delete(position.position_number);
        return [
          {
            positionNumber: position.position_number,
            description: position.description,
            groups: positionGroups,
          },
        ];
      },
    );
    const unmatchedPositions = [
      ...unmatchedGroups,
      ...[...matchedGroupsByPosition.values()].flat(),
    ].map<RoomExportPosition>((group) => ({
      positionNumber: null,
      description: null,
      groups: [group],
    }));

    return {
      room,
      total,
      positions: [...matchedPositions, ...unmatchedPositions],
    };
  });
